var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-container"},[_c('section',{staticClass:"mt-4 mb-10"},[_c('h1',{staticClass:"font-size--24",staticStyle:{"word-break":"keep-all"}},[_vm._v(" 상점 분석을 통해 진행 가능 여부를 파악하고 있습니다."),_c('br'),_c('br'),_vm._v(" 진행 가능 여부는"),_c('br'),_vm._v(" 문자로 안내 드릴 예정입니다. "),_c('br')])])])
}]

export { render, staticRenderFns }